import React, { useState, useEffect } from "react";
import Search from "../../../components/Search/Search";
import {
  IconDownload,
  IconPhoto,
  IconAudio,
  IconVideo,
  IconDocument,
} from "../../../icons/Icons";
import { getEmployeeAllDocumentsAsync } from "../../../reducers/user-reducers";
import { useDispatch } from "react-redux";
import {
  getFormatDate,
  getFileExtension,
  getRemainingStringFileName,
} from "../../../common";
import NoData from "../../../components/EmptyState/NoData";
import DownloadLink from "../../Authoring/ContentPreview/DownloadLink";
import Loader from "../../../components/Loader/Loader";
import { useDebounce } from "../../../utils/hooks/useDebounce";

const FormDocumentModalDocument = ({ documentUserId }) => {
  const dispatch = useDispatch();
  const [employeeId, setEmployeeId] = useState(documentUserId);
  const [employeeAllDocuments, setEmployeeAllDocuments] = useState([]);
  const [searchString, setSearchString] = useState("");
  const [filteredDocuments, setFilteredDocuments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [allDocuments, setAllDocuments] = useState([]);

  const iconMap = {
    photo: IconPhoto,
    audio: IconAudio,
    video: IconVideo,
    document: IconDocument,
  };

  const onSearchStringChange = (value) => {
    setSearchString(value);
  };

  useEffect(() => {
    setEmployeeId(documentUserId);
    debouncedEmployeeAllDocuments();
  }, [documentUserId]);

  useEffect(() => {
    if (searchString) {
      const filtered = allDocuments.flatMap((doc) => {
        const documentList = doc.document
          .split(",")
          .map((filename) => filename.trim().toLowerCase());

        const matchingDocuments = documentList.filter((filename) => {
          const fileName = getRemainingStringFileName(filename).toLowerCase();
          return fileName.includes(searchString.toLowerCase());
        });

        return matchingDocuments.map((file) => ({
          ...doc,
          document: file,
        }));
      });

      setFilteredDocuments(filtered);
    } else {
      setFilteredDocuments(allDocuments);
    }
  }, [searchString, allDocuments]);

  const getEmployeeAllDocuments = () => {
    setIsLoading(true);
    const reqBody = {
      searchString: "",
      EmployeeId: employeeId,
    };
    dispatch(getEmployeeAllDocumentsAsync(reqBody)).then((res) => {
      if (res.payload) {
        setEmployeeAllDocuments(res.payload);
        setFilteredDocuments(res.payload);
        setAllDocuments(res.payload);
        setIsLoading(false);
      }
    });
  };

  const debouncedEmployeeAllDocuments = useDebounce(
    getEmployeeAllDocuments,
    1000
  );

  return (
    <>
      <div>
        <div className="SeacrhDownlaod d-flex justify-content-between py-4 px-32">
          <div className="">
            <Search
              placeHolder="Search by filename"
              searchString={searchString}
              onBlur={onSearchStringChange}
            />
          </div>
        </div>

        <div className="tableComponent flex-grow-1 overflow-auto">
          <table className="table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Submitted on</th>
                <th>Form</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <div
                  className="position-absolute"
                  style={{ height: "calc(100vh - 200px)", width: "100%" }}
                >
                  <Loader type="activity" />
                </div>
              ) : filteredDocuments.length > 0 ? (
                filteredDocuments.map((document, index) => {
                  const documentList = document?.document.split(",");
                  return documentList.map((doc, docIndex) => {
                    const fileExtension = getFileExtension(doc);
                    const fileName = getRemainingStringFileName(doc);
                    const IconComponent =
                      iconMap[fileExtension] || IconDocument;

                    return (
                      <tr key={index}>
                        <td>
                          <div className="d-flex justify-content-start align-items-center">
                            <IconComponent />
                            <span className="mx-2">{fileName}</span>
                          </div>
                        </td>
                        <td>{getFormatDate(document?.uploadedDate)}</td>
                        <td>{document?.formTitle}</td>
                        <td>
                          <DownloadLink url={document.document} />
                        </td>
                      </tr>
                    );
                  });
                })
              ) : (<></>
                // <tr>
                //   <td colSpan="4" className="text-center">
                //     No documents found
                //   </td>
                // </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {filteredDocuments?.length === 0 && (
        <div className="h-100 bg-base-100 d-flex align-items-center justify-content-center text-center">
          <NoData
            msgicon="formModal"
            message="No documents to view, return later for<br/> updated information."
          />
        </div>
      )}
    </>
  );
};

export default FormDocumentModalDocument;
